import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon/index';
import {
    TEXT_ROW_ITEM_BLOCK_NAME,
    TEXT_ROW_ITEM_LABEL,
    TEXT_ROW_CLASS_TAG,
    TEXT_ROW_TOURNAMENT_LOGO,
} from './constants';
import {
    ICON_BRAND_DEFAULT_RIGHT_ARROW,
    SIZE_10x10,
} from '../../icon/constants';
import './styles/text-row.scss';

const propTypes = {
    params: PropTypes.object.isRequired,
};

class TextRow extends React.Component {
    /**
     * Default constructor.
     *
     * @param {Object} props React's properties.
     */
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { icon = true } = this.props.params;

        if (icon) {
            const arrowIcon = new Icon(ICON_BRAND_DEFAULT_RIGHT_ARROW, SIZE_10x10);
            this.rootEl.appendChild(arrowIcon.el);
        }

    }

    isTagEnabled = (tag, tagLabel) => {
        let tagHTML = null;

        if (tag) {
            tagHTML = (<span className={TEXT_ROW_CLASS_TAG}>{tagLabel}</span>);
        }

        return tagHTML;
    };

    render () {
        const {
            id,
            label,
            tag,
            tagLabel,
            logoUrl,
        } = this.props.params;

        return (
            <span id={id} className={TEXT_ROW_ITEM_BLOCK_NAME} ref={icon => {this.rootEl = icon; }}>
                {logoUrl && <img className={TEXT_ROW_TOURNAMENT_LOGO} src={logoUrl} />}
                <span className={TEXT_ROW_ITEM_LABEL}>{label}</span>
                {this.isTagEnabled(tag, tagLabel)}
            </span>
        );
    }

}

TextRow.propTypes = propTypes;

export default TextRow;
